import { assertNever } from '@kofno/piper';
import { fromNullable } from 'maybeasy';
import { Task } from 'taskarian';
import ToastsStore from '.';
import { AppyError, callApi } from '../Appy';
import { CurrentUserResource } from '../CurrentUser/Types';
import ErrorActionableReaction, { EAProps, handleError } from '../ErrorActionableReaction';
import { MissingLinkError, findLinkT } from '../LinkyLinky';
import { Link } from '../Resource/Types';
import { toastsResourceDecoder } from './Decoders';
import { State, ToastsResource } from './Types';

interface Props extends EAProps<ToastsStore> {
  currentUserResource: CurrentUserResource;
}

type ToastError = AppyError | MissingLinkError;

const handleToastsError = (store: ToastsStore) => (error: ToastError) => {
  switch (error.kind) {
    case 'missing-link-error':
      store.error(`You cannot perform this operation`);
      break;
    default:
      handleError(store, error);
  }
};

const ready = (store: ToastsStore) => (toastsResource: ToastsResource) => {
  const dismissedUUIDs = fromNullable(localStorage.getItem('dismissedToasts'))
    .getOrElseValue('')
    .split('|');
  const UUIDs = toastsResource.payload.toasts.map((t) => t.uuid);
  const validDismissedUUIDS = dismissedUUIDs.filter((x) => UUIDs.indexOf(x) >= 0);
  localStorage.setItem('dismissedToasts', validDismissedUUIDS.join('|'));
  store.ready(toastsResource);
};

type RetreivalError = MissingLinkError | AppyError;

class ToastsReactions extends ErrorActionableReaction<ToastsStore, State, Props> {
  tester = () => this.props.store.state;

  effect = (state: State) => {
    switch (state.kind) {
      case 'reloading':
      case 'loading':
        const { store } = this.props;
        Task.succeed<RetreivalError, ReadonlyArray<Link>>(this.props.currentUserResource.links)
          .andThen(findLinkT('notifications'))
          .andThen(callApi(toastsResourceDecoder, {}))
          .fork(handleToastsError(store), ready(store));
        break;
      case 'waiting':
        this.props.store.loading();
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ToastsReactions;
